import { useId } from 'react';
import svgPaths from './svgPaths';

type HandThumbProps = {
  className?: string;
  property1?: 'Thumb-down' | 'Thumb-middown' | 'Thumb-middle' | 'Thumb-midhigh' | 'Thumb-up';
};

export default function HandThumb({ className, property1 = 'Thumb-up' }: HandThumbProps) {
  const isThumbDown = property1 === 'Thumb-down';
  const isThumbMiddown = property1 === 'Thumb-middown';
  const isThumbMiddle = property1 === 'Thumb-middle';
  const isThumbMidhigh = property1 === 'Thumb-midhigh';
  const isThumbUp = property1 === 'Thumb-up';

  const mask0Id = useId();
  const mask1Id = useId();

  const rotationClass = isThumbDown
    ? '-tw-rotate-90'
    : isThumbMiddown
    ? '-tw-rotate-[45deg]'
    : isThumbMiddle
    ? 'tw-rotate-0'
    : isThumbMidhigh
    ? 'tw-rotate-[45deg]'
    : 'tw-rotate-90';

  return (
    <div className={className || 'tw-relative tw-size-[30px]'} data-name="hand thumb">
      <div
        className={`tw-relative tw-size-full tw-transition-transform tw-duration-300 tw-ease-in-out ${rotationClass}`}
      >
        <svg
          className="tw-absolute tw-block tw-w-[24px] tw-h-auto tw-top-1/2 tw-left-1/2 -tw-translate-x-1/2 -tw-translate-y-1/2"
          viewBox="0 0 35 26"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <mask
            id={mask0Id}
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="10"
            y="0"
            width="25"
            height="26"
          >
            <path
              d="M28.003 3.94611e-06C31.5034 3.6401e-06 34.2158 2.69386 34.2158 7.00078L34.2158 21.4178C34.2158 23.8405 33.6775 25.4555 30.9856 25.4555C28.0247 25.4556 28.2098 23.2458 28.2098 22.1691C28.2098 23.2458 28.0179 25.4556 25.2184 25.4556C23.0438 25.4556 22.4554 24.1222 22.3431 23.0223C22.1947 24.1222 21.4353 25.4556 19.2993 25.4556C17.0915 25.4556 16.453 24.0891 16.4268 22.9465C16.2051 24.0891 15.458 25.4556 13.5844 25.4556C11.2508 25.4556 10.501 23.3762 10.5387 22.1103L10.5387 14.807L10.5387 12.1113C10.5387 10.3167 10.501 8.8695 10.501 7.42606C10.501 3.01848 13.0036 0.158281 16.5039 2.40249e-05L28.003 3.94611e-06Z"
              fill="#FFD349"
            />
          </mask>
          <g mask={`url(#${mask0Id})`}>
            <path
              d="M4.83656 26.8362L4.83656 29.1698C4.83657 32.6692 13.6305 30.937 23.3211 30.937C33.0116 30.937 34.0884 26.6301 34.0884 15.8628C34.0884 4.01881 31.9349 -1.23989 28.1664 -1.23989L12.2847 -1.09565C9.5035 -1.09565 4.83656 3.48037 4.83656 7.78729L4.83656 12.6326L4.83656 26.8362Z"
              fill="#FFD266"
            />
            <path
              d="M13.3867 5.4534L13.3867 11.9401C13.3867 12.3743 13.0398 12.7263 12.6118 12.7263C12.1838 12.7263 11.8369 12.3743 11.8369 11.9401L11.8369 5.4534C11.8369 5.01916 12.1838 4.66714 12.6118 4.66714C13.0398 4.66714 13.3867 5.01916 13.3867 5.4534Z"
              fill="#FFE79E"
            />
            <path
              d="M28.1348 17.1215L28.1348 25.6695C28.1348 26.1038 27.7878 26.4558 27.3598 26.4558C26.9319 26.4558 26.5849 26.1038 26.5849 25.6695L26.5849 17.1215C26.5849 16.6873 26.9319 16.3353 27.3598 16.3353C27.7878 16.3353 28.1348 16.6873 28.1348 17.1215Z"
              fill="#FCB814"
            />
            <path
              d="M22.2544 17.1214L22.2544 25.6694C22.2544 26.1037 21.9075 26.4557 21.4795 26.4557C21.0515 26.4557 20.7046 26.1037 20.7046 25.6694L20.7046 17.1214C20.7046 16.6872 21.0515 16.3351 21.4795 16.3351C21.9074 16.3351 22.2544 16.6872 22.2544 17.1214Z"
              fill="#FCB814"
            />
            <path
              d="M16.4204 17.1214L16.4204 25.6694C16.4204 26.1037 16.0735 26.4557 15.6455 26.4557C15.2175 26.4557 14.8706 26.1037 14.8706 25.6694L14.8706 17.1214C14.8706 16.6872 15.2175 16.3351 15.6455 16.3351C16.0735 16.3351 16.4204 16.6872 16.4204 17.1214Z"
              fill="#FCB814"
            />
            <path
              d="M11.8369 16.3264L11.8369 14.7765C11.8369 14.3485 12.1839 14.0016 12.6118 14.0016C13.0398 14.0016 13.3868 14.3485 13.3868 14.7765L13.3868 16.3264C13.3868 16.7543 13.0398 17.1013 12.6118 17.1013C12.1839 17.1013 11.8369 16.7543 11.8369 16.3264Z"
              fill="#FFE79E"
            />
            <path
              d="M32.6057 7.00071L32.6057 25.6694L34.0059 25.6694L34.0059 7.00071C34.0059 0.951743 32.8391 1.16673 29.4044 -5.98661e-05L25.6694 -5.95395e-05C28.003 -5.97435e-05 32.6057 2.73266 32.6057 7.00071Z"
              fill="#FCB814"
            />
          </g>
          <mask id={mask1Id} style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="6" width="11" height="9">
            <path
              d="M3.07609 6.72731C1.33485 6.88209 9.93825e-08 8.34087 1.75795e-07 10.089C2.51275e-07 11.8158 1.30343 13.264 3.02067 13.4453L10.5012 14.2348L10.5012 6.06726L3.07609 6.72731Z"
              fill="#FCB814"
            />
          </mask>
          <g mask={`url(#${mask1Id})`}>
            <path
              d="M3.07609 6.72731C1.33485 6.88209 9.93825e-08 8.34087 1.75795e-07 10.089C2.51275e-07 11.8158 1.30343 13.264 3.02067 13.4453L10.5012 14.2348L10.5012 6.06726L3.07609 6.72731Z"
              fill="#FFD266"
            />
            <path
              d="M10.5009 15.1683L10.5009 5.83399L9.33407 5.83399C9.33407 14.0015 7.00048 12.8348 1.1665 12.8348C1.1665 15.1683 8.16727 15.1683 10.5009 15.1683Z"
              fill="#FCB814"
            />
          </g>
        </svg>

        {/* Sparkles — Thumb-up only */}
        {isThumbUp && (
          <div className="tw-absolute -tw-left-2.5 tw-top-[40%] -tw-rotate-90 tw-w-4 tw-h-[7px] tw-transition-opacity tw-duration-300">
            <svg className="tw-block tw-size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 15.5524 6.73249">
              <path d={svgPaths.sparkle1} fill="#36C2DB" />
              <path d={svgPaths.sparkle2} fill="#36C2DB" />
              <path d={svgPaths.sparkle3} fill="#36C2DB" />
            </svg>
          </div>
        )}

        {/* Red X — Thumb-down only */}
        {isThumbDown && (
          <div className="tw-absolute tw-left-0 tw-top-1/2 -tw-translate-x-1/2 -tw-translate-y-1/2 tw-w-[5px] tw-h-[5px] tw-transition-opacity tw-duration-300">
            <svg className="tw-block tw-size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 4.52097 4.52424">
              <path d={svgPaths.redX1} fill="#F06767" />
              <path d={svgPaths.redX2} fill="#F06767" />
            </svg>
          </div>
        )}
      </div>
    </div>
  );
}
